/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumExternerLink: {
    name: 'big-medium-externer-link';
    data: string;
} = {
    name: 'big-medium-externer-link',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M124.9 7.2a4 4 0 0 0-.13-.44 5 5 0 0 0-.15-.49 4 4 0 0 0-.26-.5c-.07-.12-.12-.25-.2-.36A5.1 5.1 0 0 0 122.77 4c-.12-.08-.24-.13-.37-.2a4 4 0 0 0-.49-.26 4 4 0 0 0-.5-.16c-.14 0-.28-.09-.43-.12a4.6 4.6 0 0 0-1-.1h-63.8a5 5 0 0 0 0 10h51.75l-55.29 55.3a5 5 0 0 0 7.08 7.08L115 20.25V72a5 5 0 0 0 10 0V8.18a4.6 4.6 0 0 0-.1-.98"/><path d="M99 67a5 5 0 0 0-5 5v43H13V34h43a5 5 0 0 0 0-10H8a5 5 0 0 0-5 5v91a5 5 0 0 0 5 5h91a5 5 0 0 0 5-5V72a5 5 0 0 0-5-5"/></svg>`,
};
